import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={10.056}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 2552 6523"
    {...props}
  >
    <defs>
      {/* <style>{".fil2{fill:#231f20}.fil0{fill:#242021}"}</style> */}
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974342556128">
        <path
          d="M1358 4758c-348 21-948-67-1018 101-30 73-28 463-17 556 26 221 185 184 394 182 368-3 735-3 1103 0 227 1 359 35 375-207 52-775-111-594-358-633 38-581 686-434 714-730 40-437-622-232-883 79-228 274-174 299-310 652z"
          className="fil0"
        />
        <path
          d="M434 4028c171 159 216 331 227 616l449-1c24-361-90-540-224-795 86-58 1106-415 1202-450 221-81 456-113 330-404-101-235-380-58-589 15-412 145-805 300-1221 447-137 48-529 152-579 248-51 98 1 266 73 325 114 93 188-14 332-1z"
          style={{
            fill: "#221e1f",
          }}
          className="fill"
        />
        <path
          d="M2186 611c-451 128-893 330-1348 483-224 76-462 157-679 246-295 120-136 502 126 435 179-46 474-168 661-238l1354-493c296-116 123-500-114-433z"
          className="fil0"
        />
        <path
          d="M2205 2116 182 2850c-125 45-206 98-167 261 90 371 447 117 914-51l1354-494c342-128 112-499-78-450z"
          className="fill"
        />
        <path
          d="M2143 1386c-580 218-1466 499-2011 723-145 59-153 135-100 293 52 154 126 182 302 115 438-167 895-329 1336-487 215-76 450-152 660-238 225-92 137-528-187-406z"
          className="fil0"
        />
        <path
          d="M1513 14c-307 104-599 209-894 320-140 53-364 83-386 233-25 176 88 343 285 287 268-74 615-225 884-323 144-53 367-90 391-230 29-162-83-354-280-287z"
          className="fill"
        />
        <path
          d="M541 6004c-120 287 165 208 715 208 524 0 883 84 742-208-88-29-1365-28-1457 0zM540 5696c-120 281 164 207 716 207 162 0 325-1 488 0 238 3 310 50 266-216-160-16-1370-27-1470 9z"
          className="fil0"
        />
        <path
          d="m1025 6522 487-1c113 0 101 20 131-61 83-224-247-162-362-162-61 0-306-12-344 8-54 30-115 216 88 216z"
          className="fill"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
